/** @jsx jsx */
import { jsx } from 'theme-ui'

import { useEffect, createRef, useState } from 'react'
let options = {
  threshold: 0.1
}

const AnimationObserver = ({ animation = 'animate__fadeIn', children }) => {
  const [isVisible, setIsVisible] = useState()

  const ref = createRef()
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries

      if (entry.isIntersecting) {
        setIsVisible(entry.isIntersecting)
      }
    }, options)

    if (ref.current) {
      observer.observe(ref.current)
    }

    return () => {
      if (ref.current) observer.unobserve(ref.current)
    }
  }, [])

  return (
    <div
      className={isVisible ? `animate__animated ${animation}` : ''}
      ref={ref}
    >
      <div sx={{ visibility: !isVisible ? 'hidden' : 'visible' }}>
        {children}
      </div>
    </div>
  )
}

export default AnimationObserver
